import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazy(() => import('./components/Helmet')),
  Layout: lazy(() => import('./components/Layout')),
  Dashboard: lazy(() => import('./containers/Dashboard')),
  CustomAudiences: lazyNamed(() => import('./containers/CustomAudiences'), 'CustomAudiences'),
  CustomAudiencesConfig: lazy(() => import('./containers/CustomAudiencesConfig')),
  IABAudiences: lazyNamed(() => import('./containers/IABAudiences'), 'IABAudiences'),
  Domains: lazyNamed(() => import('./containers/Domains'), 'Domains'),
};
